import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const NotificationDetailsRowSkeleton = () => {
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        marginHorizontal:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? 0
            : 30,
        marginTop: 30,
      }}
    >
      <View style={{ flexDirection: "row", justifyContent: "space-between" }}>
        <View>
          <Skeletons height={10} width={"80px"} />
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 107
                : 160
            }
            width={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "100px"
                : "150px"
            }
            style={{
              marginTop: 10,
              resizeMode: "contain",
            }}
          />
          <Skeletons height={10} width={"80px"} />
        </View>
        <View>
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 120
                : 150
            }
            width={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "71px"
                : "108px"
            }
            style={{
              marginTop: 10,
              resizeMode: "contain",
            }}
          />
        </View>
        <View>
          <Skeletons height={10} width={"80px"} />
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? 107
                : 160
            }
            width={
              deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                ? "100px"
                : "150px"
            }
            style={{
              marginTop: 10,
              resizeMode: "contain",
            }}
          />
          <Skeletons height={10} width={"80px"} />
        </View>
      </View>

      <View
        style={{
          // flexDirection:
          //   deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
          //     ? "column"
          //     : "row",
          flexDirection: "row",
          width: "100%",
          gap: 20,
          marginTop: 20,
          justifyContent: "space-between",
        }}
      >
        <View style={{ flexDirection: "column", gap: 10 }}>
          <View style={{ gap: 6 }}>
            <Skeletons height={25} width={"80px"} />
            <Skeletons height={25} width={"100px"} />
          </View>
          <View style={{ gap: 6 }}>
            <Skeletons height={25} width={"80px"} />
            <Skeletons height={25} width={"100px"} />
          </View>
          <View style={{ gap: 6 }}>
            <Skeletons height={25} width={"80px"} />
            <Skeletons height={25} width={"100px"} />
          </View>
          <View style={{ gap: 6 }}>
            <Skeletons height={25} width={"80px"} />
            <Skeletons height={25} width={"100px"} />
          </View>
        </View>
        <View>
          <Skeletons
            height={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 141
                : 196
            }
            width={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "123px"
                : "175px"
            }
            style={{ borderRadius: 10 }}
          />
        </View>
        <View
          style={{
            flexDirection: "column",
            gap: 10,
            justifyContent: "space-between",
          }}
        >
          <View>
            <View style={{ gap: 6, marginBottom: 6 }}>
              <Skeletons height={25} width={"80px"} />
              <Skeletons height={25} width={"100px"} />
            </View>
            <View style={{ gap: 6 }}>
              <Skeletons height={25} width={"80px"} />
              <Skeletons height={25} width={"100px"} />
            </View>
          </View>
          <View>
            <Skeletons height={30} width={"120px"} />
          </View>
        </View>
      </View>
    </View>
  );
};

export default NotificationDetailsRowSkeleton;
